import { Component, OnInit } from '@angular/core';
import { APPCONFIG } from '../../config';
import { Router } from '@angular/router';
import { generalService } from '../../services/general.service';
import { environment } from '../../../../src/environments/environment';  

@Component({
  selector: 'my-app-header',
  styles: [],
  templateUrl: './header.component.html',
  providers: [generalService]
})

export class AppHeaderComponent implements OnInit {
  public AppConfig: any;
  public NAME_COMPANY : any;
  public APP_VERSION: string = '';

  constructor(private _router:Router,
    public _generalService: generalService){}

  ngOnInit() {
    this.AppConfig = APPCONFIG;
    this.CompanyName();
     this.APP_VERSION = environment.version; // 👈 asignamos versión
  }

  logOut(){
    sessionStorage.removeItem("acslo");
  	this._router.navigate(['/login']);
  }
  CompanyName(){
    let metodo = 'usuario/getCompanyName';
        const params = {
          
            loacs: sessionStorage.getItem('acslo')
        };

        this._generalService.metodoCallParams(params, metodo).subscribe(
            (result) => {
                const tableResult = JSON.parse(result);
                this.NAME_COMPANY = tableResult[0].NAME; 
            },
            (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
            }
        );

  }
}



// WEBPACK FOOTER //
// ./src/app/layout/header/header.component.ts